export enum LOGIN {
    /**
     * @value Go back to the login
     */
    GO_BACK_TO_LOGIN = 'LOGIN.GO_BACK_TO_LOGIN',
}
